export const LABELS = {
    PATCH_COLOR: 'Patches displayed in blue will be in your school’s colors. All other patches will be as pictured.',
    US_FLAG_PATCH: 'The U.S. flag patch will automatically be placed in the top sleeve position. The field of stars will always face forward, which follows U.S. flag protocol.',
    CHOOSE_FROM_OPTIONS: 'Please choose from these options:',
    BUILD_YOUR_OWN_PACKAGE: 'BUILD YOUR OWN PACKAGE',
    PRODUCT_DESCRIPTION: 'Product Description',
    SHIPPING_DETAILS: 'Shipping Details',
    SPECIFICATIONS: 'Specifications',
    VISIT_THE_FAQS: 'Visit the FAQs',
    CHOOSE_ANOTHER: 'I WANT TO CHOOSE ANOTHER',
    KEEP_IT_AS_IS: 'KEEP IT AS IS',
    MOVE_TO_TOP_LOCATION: 'MOVE TO TOP LOCATION',
    KEEP_IT_AT_THE_BOTTOM: 'KEEP IT AT THE BOTTOM',
    REVIEW_AND_ORDER: 'Review & Order',
    NEED_CUSTOM_SIZING: 'Need Custom Sizing? ',
    BUTTONS: {
        EDIT: 'Edit',
        GO_BACK: 'GO BACK',
        KEEP_SELECTIONS: 'KEEP SELECTIONS',
        PROCEED: 'PROCEED',
        START_AGAIN: 'START AGAIN'
    },
    GENERIC: {
        CURRENT_STEP: (stepValue) => `Step ${stepValue} of ${stepValue}:` 
    }
}